<template>
  <div>
    <v-main style="padding: 0px; margin-top: 0">
      <v-chip small blue label outlined style="margin-top: 0; padding-top: 0"
        ><v-icon left> mdi-calendar </v-icon>
        {{ formatedDate }}
      </v-chip>

      <v-calendar
        :type="teamView"
        ref="fullTeamCalendar"
        locale="de"
        :now="today"
        v-model="navDate"
        :weekdays="weekformat"
        :events="allTeamEvents"
        :event-color="eventcolor"
        :event-text-color="eventcolortext"
      ></v-calendar>
    </v-main>
  </div>
</template>

<script>
export default {
  props: ["eventcolor", "eventcolortext", "shiftplan", "view", "navDate"],
  data() {
    return {
      teamView: "day",
      today: new Date().toISOString().substring(0, 10),
      focusDate: new Date(),
      weekformat: [1, 2, 3, 4, 5, 6, 0],
      allTeamEvents: [],
      maxDays: 0,
    };
  },
  computed: {
    // a computed getter
    formatedDate: function () {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      };
      if (this.navDate != undefined) {
        return new Date(this.navDate).toLocaleDateString("de-DE", options);
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    //change view with calendar icon in navbar
    changeView: function () {
      // in team view, show current day and on switch next 4 days
      if (this.teamView == "day") {
        this.teamView = "4day";
      } else {
        this.teamView = "day";
      }
    },
    // get correct time labels for shift by shortcut
    getTimeLabels: function (key) {
      if (key != undefined && key != "") {
        switch (key.toLowerCase()) {
          case "g":
            return "Frei";
          case "":
            return "Frei";
          case "f":
            return "Früh";
          case "s":
            return "Spät";
          case "n":
            return "Nacht";
          case "r":
            return "Normal";
          case "aw":
            return "Abwesend";
          case "sem":
            return "Seminar";
          case "ku":
            return "Kurzarbeit";
          case "tu":
            return "Urlaub";
          case "gz":
            return "Gleitzeit";
          case "tz":
            return "frei wg. Teilzeit";
          case "kr":
            return "Krank";
          case "kk":
            return "Kurzarb. Krank";
          case "uu":
            return "Jokertage";
          case "az":
            return "Altersfreizeit";
          default:
            return key;
        }
      }
      return key;
    },
    // load data from endpoint
    loadData: async function () {
      let self = this;

      //get correct shiftplan as json
      if (self.shiftplan != undefined) {
        // iterate over shiftplan
        for (let i = 0; i < self.shiftplan.length; i++) {
          //scroll to the current month
          self.focusDate.setDate(1);
          self.focusDate.setMonth(parseInt(self.shiftplan[i].month) - 1);
          self.focusDate.setYear(parseInt(self.shiftplan[i].year));

          //get the last day of the month e.g. 31 in December
          let copyDate = new Date(self.focusDate.getTime());
          copyDate.setMonth(copyDate.getMonth() + 1);
          copyDate.setDate(0);
          self.maxDays = copyDate.getDate();

          //load team shiftplan
          self.parseAllTeamEvents(self.shiftplan[i]);
        }
      }
    },
    // parse the events of whole team - Create data for the tab "Team" in the footer
    // The tab should display all employees that are present at a day.
    parseAllTeamEvents: function (shiftplan) {

      let employeeid = this.$store.getters.employeeid;

      //Get all shifts and iterate
      for (let i = 0; i < shiftplan.shifts.length; i++) {
        let shift = shiftplan.shifts[i];

        //Look at each day and the schedule of the shift
        for (let z = 0; z < this.maxDays && z < shift.plan.length; z++) {
          let fdate = new Date(this.focusDate.getTime());
          fdate.setDate(z + 1);

          let planShift = "n/a";
          let timeLabel = this.getTimeLabels(shift.plan[z]);

          if (shift.plan[z] != undefined && timeLabel != undefined) {
            planShift = timeLabel;
          }

          var altShiftRecords = [];

          let shiftDate = fdate.toISOString().substring(0, 10);
          let shiftName = shift.name + "- " + planShift;
          // push values to allTeamEvents array: shift data
          this.allTeamEvents.push({
            name: shiftName,
            start: shiftDate,
            end: shiftDate,
            color: "#005ABB",
          });
        }

        // iterate over workplaces from json
        for (let k = 0; k < shift.workplaces.length; k++) {
          let workplace = shift.workplaces[k];

          // iterate over workers in workplaces
          for (let l = 0; l < workplace.worker.length; l++) {
            for (
              let y = 0;
              y < this.maxDays && y < workplace.worker[l].notes.length;
              y++
            ) {
              let fdate = new Date(this.focusDate.getTime());
              fdate.setDate(y + 1);

              //logic when to show an employee
              if (
                //if he/she is not absent
                (shift.plan[y].toLowerCase() != "g" &&
                  workplace.worker[l].notes[y].trim().toLowerCase() != "aw" &&
                  workplace.worker[l].notes[y].trim().toLowerCase() != "g") || //OR
                //entire shift if absent, but employee is not absent and has a deviated entry
                //this happens when a employee is working in an alternative shift, but his shift not working
                (shift.plan[y].toLowerCase() == "g" &&
                  workplace.worker[l].notes[y].trim().toLowerCase() != "aw" &&
                  workplace.worker[l].notes[y].trim().toLowerCase() != "g" &&
                  workplace.worker[l].notes[y].trim().toLowerCase() != "")
              ) {
                let shiftDate = fdate.toISOString().substring(0, 10);
                // push additional values to allTeamEvents array: workplace worker name

                let eventRecord = {
                  name:
                    "" +
                    workplace.worker[l].name +
                    ((workplace.worker[l].notes[y] == undefined ||
                      workplace.worker[l].notes[y] == "") &&
                    workplace.worker[l].altShifts[y] == ""
                      ? ""
                      : " - " +
                        this.getTimeLabels(
                          workplace.worker[l].notes[y].trim()
                        )),
                  start: shiftDate,
                  end: shiftDate,
                  color: workplace.worker[l].employeeId != employeeid ? "#00c861": "#ff643c",
                };

                if (workplace.worker[l].altShifts[y] == "") {
                  this.allTeamEvents.push(eventRecord);
                } else {
                  altShiftRecords.push({
                    shift: {
                      name: workplace.worker[l].altShifts[y],
                      start: shiftDate,
                      end: shiftDate,
                      color: "#d72378",
                    },
                    record: eventRecord,
                  });
                }
              }
            }
          }

          altShiftRecords.forEach((altRecord) => {
            this.allTeamEvents.push(altRecord.shift);
            this.allTeamEvents.push(altRecord.record);
          });
        }
      }
    },
  },
};
</script>
